// Auraana — galeria y selector de variantes de la pagina de producto
document.addEventListener('DOMContentLoaded', function () {
  var root = document.querySelector('[data-au-producto]');
  if (!root) return;
  initGaleria(root);
  initVariantes(root);
});

function initGaleria(root) {
  var principal = root.querySelector('[data-au-imagen-principal]');
  var minis = root.querySelectorAll('[data-au-mini]');
  if (!principal || !minis.length) return;
  minis.forEach(function (btn) {
    btn.addEventListener('click', function () {
      principal.src = btn.getAttribute('data-full');
      minis.forEach(function (b) { b.classList.remove('is-active'); });
      btn.classList.add('is-active');
    });
  });
}

function initVariantes(root) {
  var variantesEl = root.querySelector('[data-au-variantes]');
  var idInput = root.querySelector('[data-au-variant-id]');
  var boton = root.querySelector('[data-au-boton-comprar]');
  var botonTexto = root.querySelector('[data-au-boton-texto]');
  var precioActual = root.querySelector('[data-au-precio-actual]');
  var precioComparado = root.querySelector('[data-au-precio-comparado]');
  var grupos = root.querySelectorAll('[data-au-opcion]');
  if (!variantesEl || !grupos.length) return;

  var variantes;
  try {
    variantes = JSON.parse(variantesEl.textContent);
  } catch (e) {
    return;
  }

  grupos.forEach(function (grupo) {
    var pills = grupo.querySelectorAll('[data-au-valor]');
    pills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        pills.forEach(function (p) { p.classList.remove('is-active'); });
        pill.classList.add('is-active');
        actualizar();
      });
    });
  });

  function valoresSeleccionados() {
    var seleccion = [];
    grupos.forEach(function (grupo) {
      var activo = grupo.querySelector('.is-active');
      seleccion.push(activo ? activo.getAttribute('data-au-valor') : null);
    });
    return seleccion;
  }

  function actualizar() {
    var seleccion = valoresSeleccionados();
    var encontrada = variantes.find(function (v) {
      var opciones = [v.option1, v.option2, v.option3];
      return seleccion.every(function (val, i) { return val === null || opciones[i] === val; });
    });
    if (!encontrada) return;

    idInput.value = encontrada.id;

    if (precioActual) precioActual.textContent = formatoDinero(encontrada.price);
    if (precioComparado) {
      if (encontrada.compare_at_price && encontrada.compare_at_price > encontrada.price) {
        precioComparado.textContent = formatoDinero(encontrada.compare_at_price);
        precioComparado.style.display = '';
      } else {
        precioComparado.style.display = 'none';
      }
    }

    if (boton) {
      boton.disabled = !encontrada.available;
      if (botonTexto) {
        botonTexto.textContent = encontrada.available
          ? botonTexto.getAttribute('data-disponible') || botonTexto.textContent
          : botonTexto.getAttribute('data-agotado') || 'Agotado';
      }
    }
  }

  function formatoDinero(centavos) {
    return (centavos / 100).toLocaleString(document.documentElement.lang || 'es-ES', {
      style: 'currency',
      currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR'
    });
  }
}
